import { Ability } from '@casl/ability'
import { getUserData, isUserLoggedIn } from '@/auth/utils'
import { initialAbility } from './config'

const userData = isUserLoggedIn() ? getUserData() : null
// Login generates only action/subject pairs; unfamiliar cached rules must not restore access.
const validRules = userData && Array.isArray(userData.ability) && userData.ability.every(rule => rule
  && typeof rule === 'object' && !Array.isArray(rule)
  && Object.keys(rule).every(key => key === 'action' || key === 'subject')
  && typeof rule.action === 'string' && rule.action.trim()
  && typeof rule.subject === 'string' && rule.subject.trim())
export default new Ability(validRules ? userData.ability : initialAbility)
